import { useSelector } from "react-redux";
import StatusModal from "./StatusModal";
import styles from "./statusModal.module.css";

// Bottom-left corner: toasts stack upwards, the newest nearest the corner.
const StatusModalStack = () => {
  const modals = useSelector((state) => state.statusModal.modals);
  if (!modals.length) return null;

  return (
    <div className={styles.stack}>
      {modals.map((item) => (
        <StatusModal
          key={item.id}
          id={item.id}
          status={item.status}
          message={item.message}
        />
      ))}
    </div>
  );
};

export default StatusModalStack;
